import '../pages/profiles/standard-block';
import '../pages/profiles/complexBlock';
import '../pages/profiles/iarBlock';
import '../pages/profiles/growthBlockSimple';
import "../pages/profiles/studentRacialMakeup-block";
import "../pages/profiles/ostBlock";
import "../pages/profiles/teacherPositionsBlock";
import "../pages/profiles/studentPopulationOverview";
import "../pages/profiles/loadingSpinner";
import "../pages/profiles/actIar";
import "../pages/profiles/cultivateImpact";

// 1. Data Converter
function convertToObjects(arr) {
    if (!arr || arr.length === 0) return [];
    const [headers, ...rows] = arr;
    return rows.map(row => {
        return headers.reduce((obj, header, index) => {
            obj[header.toLowerCase()] = row[index];
            return obj;
        }, {});
    });
}

// 2. API Wrapper
async function getAPIValues(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.error?.message || "Request failed");
        }
        return await response.json();
    } catch (error) {
        console.error("MealViewer API Error:", error.message);
        return null; // Return null so the logic can handle the failure
    }
}

// 3. Service Layer
async function getMealData() {
    const googleAPIkey = "AIzaSyCbZJULn81gkx0aTFdn4BTzTM9-4WP7lYo";
    const spreadsheetID = "1LB3awIEo5dyGXvq36wJxCbynAd-QmjjxaDkEOcK-3S0";
    const menuAPI = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetID}/values/Sheet1?key=${googleAPIkey}`;

    const data = await getAPIValues(menuAPI);
    return data && data.values ? convertToObjects(data.values) : [];
}

// 4. DOM Updater
function updateAllSchoolLunchLinks(getSchoolData) {
    // Matches the class name used in your C# TinyMCE config
    const schoolLinks = document.querySelectorAll('a.school-lunch-link');

    const targetUrl = (getSchoolData && getSchoolData.url)
        ? getSchoolData.url
        : "https://schools.mealviewer.com/district/Chicago%20Public%20Schools";

    schoolLinks.forEach(link => {
        link['href'] = targetUrl;
    });
}

// 5. Orchestrator (The "Next Step" Function)
async function initMealLinks(schoolId) {
    // Fetch all data from Google Sheets
    const allSchools = await getMealData();

    // Find the specific school record
    const specificSchool = allSchools.find(s => s.id == schoolId);

    // Update the UI
    updateAllSchoolLunchLinks(specificSchool);
}

document.addEventListener("DOMContentLoaded", () => {
    // 1. Select all headers with the specific aria-block-type
    const schoolrecognitionHeaders = document.querySelectorAll('div[aria-block-type="schoolrecognition"]');
    console.log('HEADERS: ', schoolrecognitionHeaders)
    schoolrecognitionHeaders.forEach(header => {
        // 2. Get the immediate next element
        const nextElement = header.nextElementSibling;

        // 3. Check if the next element is NOT the schoolRecognition-block

        if (nextElement && nextElement.classList.contains('schoolRecognition-block') && nextElement.innerHTML.trim() === "") {
            header['style'].display = 'none';
            nextElement['style'].display = 'none'; // Hide the empty container too
        }
    });
    const mainElement = document.querySelector('main.school-profile') as HTMLElement | null;

    if (mainElement) {
        const schoolId = mainElement.dataset['schoolId'];

        if (schoolId && schoolId !== "0") {
            initMealLinks(schoolId);
        } else {
            // Fallback to district link
            updateAllSchoolLunchLinks(undefined);
        }
    }

    document.querySelectorAll<HTMLElement>('.bas-table').forEach(el => el.style.display = 'none');
    const defaultElement = document.getElementById("Common_Unit_Assessments");
    if (defaultElement) defaultElement.style.display = "block";
    const selectElement = document.getElementById("BallancedAssessmentSelect") as HTMLSelectElement | null;
    if (!selectElement) return;
    selectElement.addEventListener("change", (event) => {
        const target = event.target as HTMLSelectElement;
        const selectedValue = target.value;
        document.querySelectorAll<HTMLElement>('.bas-table').forEach(el => el.style.display = 'none');
        const selectedTable = document.getElementById(selectedValue);
        if (selectedTable) selectedTable.style.display = "block";
    });


});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll<HTMLElement>('.no-metric-data').forEach(el => {
        console.log('found el', el)
        el.parentElement.classList.add('no-metric-data');
    });
});